import { useI18n, localeNames, type Locale } from '../i18n';

export default function LanguageSwitcher() {
    const { locale, setLocale } = useI18n();

    return (
        <div className="relative">
            <select
                value={locale}
                onChange={(e) => setLocale(e.target.value as Locale)}
                className="px-3 py-1.5 border border-gray-300 rounded-md text-sm bg-white hover:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-500 cursor-pointer appearance-none pr-8"
                style={{ minWidth: '140px' }}
            >
                {(Object.keys(localeNames) as Locale[]).map((loc) => (
                    <option key={loc} value={loc}>
                        {localeNames[loc].flag} {localeNames[loc].name}
                    </option>
                ))}
            </select>
            <div className="absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400">
                ▼
            </div>
        </div>
    );
}
